import { BrowserUtils } from '@common/utils/browser';

export const InspectService: KyPortalService.InspectService = {
  isInspect: BrowserUtils.isInspect,
  isHeadless: BrowserUtils.checkHeadless()
};
